class Tooltip
  constructor: (@element) ->
    placement = @element.data('tooltip-placement')
    placement ||= 'top'
    tooltipClass = @element.data('tooltip-class')
    @element.tooltip
#toggle: "popover"
#trigger: "hover focus"
      html: true
#customClass: tooltipClass
      placement: placement
      title: $(this).data('title')
#viewport: '#viewport'
      delay: {  'hide': 5000 }

$(document).ready ->
  $('*[data-behavior=Tooltip]').each ->
    new Tooltip($(@))
